import React from 'react'
import SectionWrapper from '../../Components/SectionWrapper'
import footerLogo from '../../../assets/papper-logo.png'
import telegram from "../../../assets/telegram.png";
import twitter from "../../../assets/twitter.png";
import { Box } from '@mui/material'
import { MenuLink } from '../../Components/LockerMenu/styles'

const Footer = () => {
  return (
    <SectionWrapper>
        <div style={{textAlign:'center'}}>
            <img src={footerLogo} alt="pepper-footer-logo" style={{maxWidth: 200, with: '100%', height: 'auto'}} />
            <Box>
            <MenuLink href="https://t.me/peppererc20" target="blank" className="social">
                <img src={telegram} alt="telegram" target="_blank" />
            </MenuLink>
            <MenuLink href="https://twitter.com/peppererc20" target="blank"  className="social">
                <img src={twitter} alt="twitter" target="_blank" />
            </MenuLink>
            </Box>
        </div>
    </SectionWrapper>
  )
}

export default Footer